import { Theme } from '@mui/material/styles'

const GlobalStyles = (theme: Theme) => {
    return {
        '.test': { marginBottom: '1rem' }
    }
}

export default GlobalStyles
